import React from 'react';
import ContentCard from '../ContentCard';

const Cookies = () => {
    return <div className='left-align'>
    <ContentCard title="Do we use Cookies?" content="Yes, we do. You can opt out from having any cookies placed on your computer through the cookie banner.  You can also change your consent by clicking the link to the Privacy Setttings in the bottom-left corner of the screen." />


  </div>;
};

export default Cookies;